import { render, staticRenderFns } from "./EditLocationPage.vue?vue&type=template&id=05522935"
import script from "./EditLocationPage.vue?vue&type=script&lang=js"
export * from "./EditLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports